import { render, staticRenderFns } from "./Toolbar2_backoffice.vue?vue&type=template&id=6293b5f3&scoped=true&"
import script from "./Toolbar2_backoffice.vue?vue&type=script&lang=js&"
export * from "./Toolbar2_backoffice.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar2_backoffice.vue?vue&type=style&index=0&id=6293b5f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6293b5f3",
  null
  
)

export default component.exports